import axios from "axios";
import "./Weather.css";
import { useState } from "react";
import WeatherInfo from "./WeatherInfo";
import LoadingIcon from "./LoadingIcon";
import WeatherForecast from "./WeatherForecast";

export default function Weather(props) {
  const [WeatherData, setWeatherData] = useState({ ready: false });
  const [city, setCity] = useState(props.defaultCity);

  function handleResponse(response) {
    setWeatherData({
      ready: true,
      coordenates: response.data.coord,
      date: new Date(response.data.dt * 1000),
      icon: response.data.weather[0].icon,
      temperature: response.data.main.temp,
      city: response.data.name,
      description: response.data.weather[0].description,
      humidity: response.data.main.humidity,
      wind: response.data.wind.speed,
    });
  }

  function search() {
    const apikey = `062e2c91ccb0878db76c1e378379244b`;
    let apiurl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=metric&appid=${apikey}`;
    axios.get(apiurl).then(handleResponse);
  }
  function handleSubmit(event) {
    event.preventDefault();
    search();
  }

  function handleCityChange(event) {
    setCity(event.target.value);
  }
  if (WeatherData.ready) {
    return (
      <div className="body">
        <form
          className="row d-flex justify-content-center combo"
          onSubmit={handleSubmit}
        >
          <input
            type="search"
            className=" col-9 searchBar"
            placeholder="Search city"
            onChange={handleCityChange}
          ></input>
          <input type="submit" className="col-2 submitButton" value="Search" />
        </form>
        <WeatherInfo data={WeatherData} />;
        <WeatherForecast coordenates={WeatherData.coordenates} />
      </div>
    );
  } else {
    search();
    return <LoadingIcon />;
  }
}
